import type { FC } from 'react';
import { IconContainer } from './LinkIcon.styles';

export interface LinkIconProps {
    iconSize?: number;
    iconColor?: string;
    containerSize?: number;
    containerBackgroundColor?: string;
    containerBorderColor?: string;
    containerBorderWidth?: number;
    className?: string;
}

const LinkIcon: FC<LinkIconProps> = ({
    iconSize = 10,
    iconColor = '#0022E6',
    containerSize,
    containerBackgroundColor,
    containerBorderColor,
    containerBorderWidth,
    className,
}) => {
    return (
        <IconContainer
            className={className}
            $size={containerSize}
            $backgroundColor={containerBackgroundColor}
            $borderColor={containerBorderColor}
            $borderWidth={containerBorderWidth}
        >
            <svg width={iconSize} height={iconSize} viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.5998 0.799988C5.26843 0.799988 4.9998 1.06862 4.9998 1.39999C4.9998 1.73136 5.26843 1.99999 5.5998 1.99999H7.15128L3.37554 5.77572C3.14123 6.01004 3.14123 6.38994 3.37554 6.62425C3.60985 6.85857 3.98975 6.85857 4.22407 6.62425L7.9998 2.84852V4.39999C7.9998 4.73136 8.26843 4.99999 8.5998 4.99999C8.93118 4.99999 9.1998 4.73136 9.1998 4.39999V1.39999C9.1998 1.06862 8.93118 0.799988 8.5998 0.799988H5.5998Z" fill={iconColor} />
                <path d="M1.9998 1.99999C1.33706 1.99999 0.799805 2.53725 0.799805 3.19999V7.99999C0.799805 8.66273 1.33706 9.19999 1.9998 9.19999H6.7998C7.46255 9.19999 7.9998 8.66273 7.9998 7.99999V6.19999C7.9998 5.86862 7.73118 5.59999 7.3998 5.59999C7.06843 5.59999 6.7998 5.86862 6.7998 6.19999V7.99999H1.9998V3.19999L3.7998 3.19999C4.13118 3.19999 4.3998 2.93136 4.3998 2.59999C4.3998 2.26862 4.13118 1.99999 3.7998 1.99999H1.9998Z" fill={iconColor} />
            </svg>
        </IconContainer>
    );
};

export default LinkIcon;
